import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
      color: 'white',
      padding: '40px 20px',
      marginTop: '80px',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '30px',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          <a 
            href="/terms.html" 
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Terms of Service
          </a>
          <a 
            href="/privacy.html" 
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Privacy Policy
          </a>
          <a 
            href="mailto:support@teachermaterial.app"
            style={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            Contact Support
          </a>
        </div>
        
        <div style={{
          fontSize: '13px',
          opacity: 0.8,
          marginTop: '15px'
        }}>
          © 2026 Teacher Material LLC. All rights reserved.
        </div>
      </div>
    </footer>
  );
}